import type { RouteRecordRaw } from 'vue-router'

export const TeacherRoutes: RouteRecordRaw[] = [
  {
    path: '/teachers',
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: ':teacherId',
        name: 'teacher-profile',
        component: () => import('@/views/teachers/profile.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { text: 'دوره‌ها', to: { name: 'course-list' } },
            { text: 'مدرس' }
          ]
        }
      }
    ]
  }
]
